"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.baseClassName = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const rebass_1 = require("rebass");
const join_1 = tslib_1.__importDefault(require("../utils/join"));
exports.baseClassName = 'ab-Textarea';
const Textarea = React.forwardRef((props, ref) => {
    let { disabled, className } = props, textareaProps = tslib_1.__rest(props, ["disabled", "className"]);
    let type = 'text';
    if (textareaProps && textareaProps.type) {
        type = textareaProps.type;
    }
    if (type === 'string') {
        type = 'text';
    }
    return (React.createElement(rebass_1.Box, Object.assign({ ref: ref, as: "textarea" }, textareaProps, { type: type, disabled: disabled, className: (0, join_1.default)(className, exports.baseClassName, disabled ? `${exports.baseClassName}--disabled` : '') })));
});
exports.default = Textarea;
